import { alertModalKey } from './alert-modal.comp';
export var createAlertModalDriver = function (wrapper) {
    var base = wrapper.$("." + alertModalKey);
    return {
        text: function () { return base.$('.body').text(); },
        close: function () { return base.$('.close').click(); },
        base: base
    };
};
//# sourceMappingURL=driver.js.map